import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

import eggMachine from './eggMachine'

//  3个开头字母 4个中间字母 5个结尾字母 + 时间戳
const GameComponents = {
  fffmmmmooooo: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-components-fffmmmmooooo" */ '~/pages/game/components/Fomo/Page/index'
      )
  ),
  tttmmmmppppp: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-tttmmmmppppp" */ '~/pages/game/ThridMidPage'
      )
  ),
  hhheeeeggggg: loadable(
    () =>
      import(
        // /404
        /* webpackChunkName: "page-hhheeeeggggg" */ '~/pages/game/HitEgg'
      )
  ),
  gggmmmmeeeee: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-gggmmmmeeeee" */ '~/pages/game/GoldMiner'
      )
  ),
  ggghhhhaaaaabbbnnnnrrrrr: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-ggghhhhaaaaa-bbbnnnnrrrrr" */ '~/pages/game/components/Fomo/Banner'
      )
  ),
  ggghhhhaaaaa: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-ggghhhhaaaaa" */ '~/pages/game/GreedyHiya'
      )
  ),
  gggccccsssss: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-gggccccsssss" */ '~/pages/game/GreedyCat/Rules'
      )
  ),
  gggccccddddd: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-gggccccddddd" */ '~/pages/game/GreedyCat/Record'
      )
  ),
  gggcccckkkkk: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-gggcccckkkkk" */ '~/pages/game/GreedyCat/Rank'
      )
  ),
  gggcccchhhhh: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-gggcccchhhhh" */ '~/pages/game/GreedyCat/History'
      )
  ),
  gggccccttttt: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-gggccccttttt" */ '~/pages/game/GreedyCat'
      )
  ),
  gggrrrrttttt: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-gggrrrrttttt" */ '~/pages/game/GreedyRocket'
      )
  ),
  gggmmmmsssss: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-gggmmmmsssss" */ '~/pages/game/GreedyMold/Rules'
      )
  ),
  gggmmmmooooo: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-gggmmmmooooo" */ '~/pages/game/GreedyMold/Record'
      )
  ),
  gggmmmmrrrrr: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-gggmmmmrrrrr" */ '~/pages/game/GreedyMold/Rank'
      )
  ),
  gggmmmmhhhhh: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-gggmmmmhhhhh" */ '~/pages/game/GreedyMold/History'
      )
  ),
  gggmmmmddddd: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-gggmmmmddddd" */ '~/pages/game/GreedyMold'
      )
  ),
  gggppppooooobbbnnnnrrrrr: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-gggppppooooo-bbbnnnnrrrrr" */ '~/pages/game/GreedyProGame/Banner'
      )
  ),
  gggppppooooo: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-gggppppooooo" */ '~/pages/game/GreedyProGame'
      )
  ),
  gggyyyybbbbbeeerrrreeeee: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-gggyyyybbbbb-tttcccceeeee" */ '~/pages/game/GreedyBox/Throne/components/entrance'
      )
  ),
  gggyyyybbbbb: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-gggyyyybbbbb" */ '~/pages/game/GreedyBox'
      )
  ),
  jjjggggeeeee: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-components-jjjggggeeeee" */ '~/pages/game/components/justgame/page'
      )
  ),
  jjjggggeeeeewwweeeeeeeee: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-components-jjjggggeeeee-wwweeeeeeeee" */ '~/pages/game/components/justgame/whele'
      )
  ),
  lllbbbblllll: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-lllbbbblllll" */ '~/pages/game/LuckyBigWheel'
      )
  ),
  wwwccccppppp: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-wwwccccppppp" */ '~/pages/game/WorldCup'
      )
  ),
  gggbbbbxxxxx: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-gggbbbbxxxxx" */ '~/pages/game/guessbox'
      )
  ),
  gggbbbbxxxxxttteeeeeeeee: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-gggbbbbxxxxx-ttteeeeeeeee" */ '~/pages/game/guessbox/Throne/components/entrance'
      )
  ),
  gggggggttttt: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-gggggggttttt" */ '~/pages/game/GuessGift'
      )
  ),
  sssmmmmeeeee: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-sssmmmmeeeee" */ '~/pages/game/SlotMidPage'
      )
  ),
  fffssssttttt: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-fffssssttttt" */ '~/pages/game/fruitSlot'
      )
  ),
  rrrlllleeeee: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-rrrlllleeeee" */ '~/pages/game/roulette'
      )
  ),
  lllssssttttt: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-lllssssttttt" */ '~/pages/game/LuckySlot'
      )
  ),
  hhhggggeeeee: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-hhhggggeeeee" */ '~/pages/game/HorseGame'
      )
  ),
  tttppppiiiii: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-tttppppiiiii" */ '~/pages/game/TeenPatti'
      )
  ),
  tttppppiiiiieeetttteeeee: loadable(
    () =>
      import(
        // /404
        /* webpackChunkName: "page-game-tttppppiiiii-eeetttteeeee" */ '~/pages/game/TeenPatti/entrance'
      )
  ),
  gggssssttttt0303: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-gggssssttttt0303" */ '~/pages/game/GreedySports'
      )
  ),
  gggsssstttttwwwwww: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-gggsssstttttwwwwww" */ '~/pages/game/GreedySports/whele'
      )
  ),
  sssccccrrrrrgggggg: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-sssccccrrrrrgggggg" */ '~/pages/game/components/silverCoins/roomGuidPage'
      )
  ),
  sssccccrrrrruuuuuu: loadable(
    () =>
      import(
        /* webpackChunkName: "page-game-sssccccrrrrruuuuuu" */ '~/pages/game/components/silverCoins/retainUserPage'
      )
  ),
}

export default [
  {
    path: '/game/gggggggttttt',
    exact: true,
    component: GameComponents.gggggggttttt,
  },
  {
    path: '/game/GuessGift',
    exact: true,
    component: GameComponents.gggggggttttt,
  },
  {
    path: '/game/fffssssttttt',
    exact: true,
    component: GameComponents.fffssssttttt,
  },
  {
    path: '/game/fruitSlot',
    exact: true,
    component: GameComponents.fffssssttttt,
  },
  {
    path: '/game/fruitTols',
    exact: true,
    component: GameComponents.fffssssttttt,
  },
  {
    path: '/game/rrrlllleeeee',
    exact: true,
    component: GameComponents.rrrlllleeeee,
  },
  {
    path: '/game/roulette',
    exact: true,
    component: GameComponents.rrrlllleeeee,
  },
  {
    path: '/game/lllssssttttt',
    exact: true,
    component: GameComponents.lllssssttttt,
  },
  {
    path: '/game/LuckySlot',
    exact: true,
    component: GameComponents.lllssssttttt,
  },
  {
    path: '/game/LuckyTols',
    exact: true,
    component: GameComponents.lllssssttttt,
  },
  {
    path: '/game/hhhggggeeeee',
    exact: true,
    component: GameComponents.hhhggggeeeee,
  },
  {
    path: '/game/HorseGame',
    exact: true,
    component: GameComponents.hhhggggeeeee,
  },
  {
    path: '/game/wwwccccppppp',
    exact: true,
    component: GameComponents.wwwccccppppp,
  },
  {
    path: '/game/WorldCup',
    exact: true,
    component: GameComponents.wwwccccppppp,
  },
  {
    path: '/game/lllbbbblllll',
    exact: true,
    component: GameComponents.lllbbbblllll,
  },
  {
    path: '/game/LuckyBigWheel',
    exact: true,
    component: GameComponents.lllbbbblllll,
  },
  {
    path: '/game/gggbbbbxxxxx',
    exact: true,
    component: GameComponents.gggbbbbxxxxx,
  },
  {
    path: '/game/guessbox',
    exact: true,
    component: GameComponents.gggbbbbxxxxx,
  },
  {
    path: '/game/gggbbbbxxxxx/ttteeeeeeeee',
    exact: true,
    component: GameComponents.gggbbbbxxxxxttteeeeeeeee,
  },
  {
    path: '/game/guessbox/throneEntrance',
    exact: true,
    component: GameComponents.gggbbbbxxxxxttteeeeeeeee,
  },
  {
    path: '/game/gggyyyybbbbb',
    exact: true,
    component: GameComponents.gggyyyybbbbb,
  },
  {
    path: '/game/GreedyBox',
    exact: true,
    component: GameComponents.gggyyyybbbbb,
  },
  {
    path: '/game/gggyyyybbbbb/eeerrrreeeee',
    exact: true,
    component: GameComponents.gggyyyybbbbbeeerrrreeeee,
  },
  {
    path: '/game/GreedyBox/throneEntrance',
    exact: true,
    component: GameComponents.gggyyyybbbbbeeerrrreeeee,
  },
  {
    path: '/game/LuckyHiya',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-LuckyHiya" */ '~/pages/game/LuckyHiya'
        )
    ),
  },
  {
    path: '/game/ggghhhhaaaaa',
    exact: true,
    component: GameComponents.ggghhhhaaaaa,
  },
  {
    path: '/game/GreedyHiya',
    exact: true,
    component: GameComponents.ggghhhhaaaaa,
  },
  {
    path: '/game/ggghhhhaaaaa/bbbnnnnrrrrr',
    exact: true,
    component: GameComponents.ggghhhhaaaaabbbnnnnrrrrr,
  },
  {
    path: '/game/GreedyHiya/banner',
    exact: true,
    component: GameComponents.ggghhhhaaaaabbbnnnnrrrrr,
  },
  // 扭蛋机
  ...eggMachine,
  {
    path: '/game/gggppppooooo/:gameId',
    exact: true,
    component: GameComponents.gggppppooooo,
  },
  {
    path: '/game/GreedyPro/:gameId',
    exact: true,
    component: GameComponents.gggppppooooo,
  },
  {
    path: '/game/gggppppooooo/bbbnnnnrrrrr/:gameId',
    exact: true,
    component: GameComponents.gggppppooooobbbnnnnrrrrr,
  },
  {
    path: '/game/GreedyPro/banner/:gameId',
    exact: true,
    component: GameComponents.gggppppooooobbbnnnnrrrrr,
  },
  {
    // TP游戏
    path: '/game/tttppppiiiii',
    exact: true,
    component: GameComponents.tttppppiiiii,
  },
  {
    // TP游戏
    path: '/game/TeenPatti',
    exact: true,
    component: GameComponents.tttppppiiiii,
  },
  {
    // TP游戏banner
    path: '/game/tttppppiiiii/eeetttteeeee',
    exact: true,
    component: GameComponents.tttppppiiiiieeetttteeeee,
  },
  {
    // TP游戏banner
    path: '/game/TeenPatti/jpEntance',
    exact: true,
    component: GameComponents.tttppppiiiiieeetttteeeee,
  },
  {
    // 砸金蛋游戏
    path: '/game/hhheeeeggggg',
    exact: true,
    component: GameComponents.hhheeeeggggg,
  },
  {
    // 砸金蛋游戏
    path: '/game/HitEgg',
    exact: true,
    component: GameComponents.hhheeeeggggg,
  },
  {
    // slot游戏中转页
    path: '/game/sssmmmmeeeee',
    exact: true,
    component: GameComponents.sssmmmmeeeee,
  },
  {
    // slot游戏中转页
    path: '/game/SlotMidPage',
    exact: true,
    component: GameComponents.sssmmmmeeeee,
  },
  {
    // slot游戏中转页
    path: '/game/MidPage',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-SlotMidPage" */ '~/pages/game/SlotMidPage'
        )
    ),
  },
  {
    // 通用三方游戏中转页
    path: '/tttmmmmppppp/:type',
    exact: true,
    component: GameComponents.tttmmmmppppp,
  },
  {
    // 通用三方游戏中转页
    path: '/gameTP/:type',
    exact: true,
    component: GameComponents.tttmmmmppppp,
  },
  {
    // 游戏记录页
    path: '/H5GamePage/GameScoreRecord',
    exact: true,
    component: loadable(
      () =>
        import(
          // /404
          /* webpackChunkName: "page-game-H5GamePage-GameScoreRecord" */ '~/pages/game/H5GamePage/GameScoreRecord'
        )
    ),
  },
  // greedy模版游戏
  {
    path: '/game/gggmmmmddddd/:gameId',
    exact: true,
    component: GameComponents.gggmmmmddddd,
  },
  // greedy模版游戏
  {
    path: '/game/GreedyMold/:gameId',
    exact: true,
    component: GameComponents.gggmmmmddddd,
  },
  {
    path: '/game/gggmmmmhhhhh',
    exact: true,
    component: GameComponents.gggmmmmhhhhh,
  },
  {
    path: '/game/GreedyMoldHistory',
    exact: true,
    component: GameComponents.gggmmmmhhhhh,
  },
  {
    path: '/game/gggmmmmrrrrr',
    exact: true,
    component: GameComponents.gggmmmmrrrrr,
  },
  {
    path: '/game/GreedyMoldRank',
    exact: true,
    component: GameComponents.gggmmmmrrrrr,
  },
  {
    path: '/game/gggmmmmooooo',
    exact: true,
    component: GameComponents.gggmmmmooooo,
  },
  {
    path: '/game/GreedyMoldRecord',
    exact: true,
    component: GameComponents.gggmmmmooooo,
  },
  {
    path: '/game/gggmmmmsssss',
    exact: true,
    component: GameComponents.gggmmmmsssss,
  },
  {
    path: '/game/GreedyMoldRules',
    exact: true,
    component: GameComponents.gggmmmmsssss,
  },
  {
    path: '/game/gggmmmmeeeee',
    exact: true,
    component: GameComponents.gggmmmmeeeee,
  },
  {
    path: '/game/GoldMiner',
    exact: true,
    component: GameComponents.gggmmmmeeeee,
  },
  {
    path: '/game/gggrrrrttttt',
    exact: true,
    component: GameComponents.gggrrrrttttt,
  },
  {
    path: '/game/GreedyRocket',
    exact: true,
    component: GameComponents.gggrrrrttttt,
  },
  {
    path: '/game/gggccccttttt/:gameId',
    exact: true,
    component: GameComponents.gggccccttttt,
  },
  // GreedyMold换皮成GreedyCat
  {
    path: '/game/GreedyCat/:gameId',
    exact: true,
    component: GameComponents.gggccccttttt,
  },
  {
    path: '/game/gggcccchhhhh',
    exact: true,
    component: GameComponents.gggcccchhhhh,
  },
  {
    path: '/game/GreedyCatHistory',
    exact: true,
    component: GameComponents.gggcccchhhhh,
  },
  {
    path: '/game/gggcccckkkkk',
    exact: true,
    component: GameComponents.gggcccckkkkk,
  },
  {
    path: '/game/GreedyCatRank',
    exact: true,
    component: GameComponents.gggcccckkkkk,
  },
  {
    path: '/game/gggccccddddd',
    exact: true,
    component: GameComponents.gggccccddddd,
  },
  {
    path: '/game/GreedyCatRecord',
    exact: true,
    component: GameComponents.gggccccddddd,
  },
  {
    path: '/game/gggccccsssss',
    exact: true,
    component: GameComponents.gggccccsssss,
  },
  {
    path: '/game/GreedyCatRules',
    exact: true,
    component: GameComponents.gggccccsssss,
  },
  {
    path: '/gamecenter',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-gameCenter" */ '~/pages/game/GameCenter'
        )
    ),
  },
  // fomo
  {
    path: '/game/fffmmmmooooo',
    exact: true,
    component: GameComponents.fffmmmmooooo,
  },
  {
    path: '/game/fomo',
    exact: true,
    component: GameComponents.fffmmmmooooo,
  },
  {
    path: '/game/jjjggggeeeee',
    exact: true,
    component: GameComponents.jjjggggeeeee,
  },
  {
    path: '/game/justgame',
    exact: true,
    component: GameComponents.jjjggggeeeee,
  },
  {
    path: '/game/jjjggggeeeee/wwweeeeeeeee',
    exact: true,
    component: GameComponents.jjjggggeeeeewwweeeeeeeee,
  },
  {
    path: '/game/justwhele',
    exact: true,
    component: GameComponents.jjjggggeeeeewwweeeeeeeee,
  },
  {
    path: '/game/rrrllllddddd',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-components-rrrllllddddd" */ '~/pages/game/RoyalWild'
        )
    ),
  },
  {
    path: '/game/gggssssttttt0303/:gameId',
    exact: true,
    component: GameComponents.gggssssttttt0303,
  },
  {
    path: '/game/gggsssstttttwwwwww/:gameId',
    exact: true,
    component: GameComponents.gggsssstttttwwwwww,
  },
  {
    // 银币游戏房间引导弹窗
    path: '/game/sssccccrrrrrgggggg',
    exact: true,
    component: GameComponents.sssccccrrrrrgggggg,
  },
  {
    // 银币游戏留存用户弹窗
    path: '/game/sssccccrrrrruuuuuu',
    exact: true,
    component: GameComponents.sssccccrrrrruuuuuu,
  },
] as RouteConfig[]
